import React from "react";
import { LoginProps } from "./Login";
import { useNavigate } from "react-router-dom";

const UserList = ({ loginAccount, step, setStep, saveAccountDataAndLogin }: LoginProps) => {
  const navigate = useNavigate();

  return (
    <div className="wrapper">
      <img
        src={`${process.env.PUBLIC_URL}/svg/throoLogo.svg`}
        alt="스루로고"
        className="logo"
      />
      <div className="listWrap">
        {loginAccount && loginAccount.length > 0 && loginAccount.map((item: any, index: number) => {
          let sPhoneNumber = item.phone_number;
          try {
            sPhoneNumber = sPhoneNumber.trim().replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3").replace("--", "-");
          } catch (error) {

          }
          return (
            <div className="buttonBorder" key={index}>
              <button
                onClick={() => {
                  if (item.use_password === 1) {
                    navigate("/payment/password", { state: { passwordType: "login", loginAccount: JSON.stringify(item) } })
                  } else {
                    let oAccountData: any = item;
                    if (saveAccountDataAndLogin) {
                      saveAccountDataAndLogin(oAccountData);
                    }
                  }
                }}
              >
                <h1>{sPhoneNumber}</h1>
                <h1>{item.full_name}</h1>
              </button>
            </div>
          )
        })}
        <div className="buttonBorder">
          <button
            onClick={() => {
              if (setStep) setStep(1);
            }}
          >
            <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="plus" />
            <h1>사용자 추가</h1>
          </button>
        </div>
      </div>
    </div>
  );
};
export default UserList;
